<template>
  <div class="main">
    <el-row>
      <el-col :span="24">
        <el-row :gutter="40">
          <el-col :span="16">
            <div class="content kefan">
              <!-- 确认所在园区  -->
              <div class="range" id="glhtrk">
                <h4 class="title">管理后台入口</h4>
                <el-divider></el-divider>
                <p class="enterance">
                  <ul>
                    <li>1.智慧湾：https://admin.kefan.com/</li>
                    <li>2.智慧坊：https://zhf.wis-p.cn/</li>
                    <li>3.交运智慧湾：https://jyzhw.jy-wisdombay.cn/</li>
                    <li>4.智慧七立方：https://wis777.kefan.com/</li>
                    <li>5.科房旗下园区：https://kf.kefan.com/</li>
                  </ul>
                </p>
              </div>
              <!-- 合同查找 -->
              <div class="range" id="htcz">
                <h4 class="title">合同查找</h4>
                <el-divider></el-divider>
                <p class="describe">
                  1.点击左侧栏目“合同管理”进入到合同管理页面（如图1.8）
                </p>
                <el-image 
                style="width:100%;"
                :src="img.aurl[0]"
                :preview-src-list="img.aurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.8</p>
                <p class="describe">
                  2.可在红色方框选中区域（如图1.9）对合同进行筛选（合同名称、房间、到期日范围、合同状态、合同类型等）随即跳出所选合同
                </p>
                <el-image 
                style="width:100%;"
                :src="img.burl[0]"
                :preview-src-list="img.burl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.9</p>
              </div>

              <!-- 合同添加 -->
              <div class="range" id="httj">
                <h4 class="title">合同添加</h4>
                <el-divider></el-divider>
                    <p class="describe">
                     1.点击页面右上角添加合同（如图1.10），填入合同相关内容并与原合同对应一致（如图1.11、图1.12）
                    </p>
                    <el-image 
                style="width:85%;"
                :src="img.curl[0]"
                :preview-src-list="img.curl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.10</p>
                <el-image 
                style="width:100%;"
                :src="img.durl[0]"
                :preview-src-list="img.durl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.11</p>
                <el-image 
                style="width:100%;"
                :src="img.eurl[0]"
                :preview-src-list="img.eurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.12</p>
                <p class="describe">
                     2.点击页面最下方蓝色按钮“保存”（如图1.13）即可保存当前合同完成合同添加
                </p>
                <el-image 
                style="width:85%"
                :src="img.furl[0]"
                :preview-src-list="img.furl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.13</p>
                <p class="describe">
                     3.点击页面最下方黄色按钮“发起钉钉审批”（如上图1.13-1）
                </p>
                <el-image 
                style="width:85%"
                :src="img.gurl[0]"
                :preview-src-list="img.gurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.13-1</p>
                <!-- 4 -->
                <p class="describe">
                     4.填写相关信息、上传相关附件并选择审批人抄送人完成提交（如图1.14）
                </p>
                <el-image 
                style="width:95%;"
                :src="img.hurl[0]"
                :preview-src-list="img.hurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.14</p>
              </div>
              <!-- 合同修改 -->
              <div class="range" id="htxg">
                <h4 class="title">合同修改</h4>
                <el-divider></el-divider>
                    <p class="describe">
                     1.点击更多操作中的“合同修改”（如图1.15）
                    </p>
                    <el-image 
                style="width:100%"
                :src="img.iurl[0]"
                :preview-src-list="img.iurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.15</p>
                <p class="describe">
                  2.若当前合同已处于正常状态，则只能修改合同编号、合同类型、单位名称、单位联系人、租赁物业等图中白色方框内容（如图1.16）
                </p>
                <el-image 
                style="width:100%"
                :src="img.jurl[0]"
                :preview-src-list="img.jurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.16</p>
                <p class="describe">
                  3.若需要修改合同中灰色方框内容，则需要把合同恢复至预签状态，操作步骤如下：点击更多操作中的“合同账单”（如图1.17）
                </p>
                <el-image 
                style="width:100%;"
                :src="img.kurl[0]"
                :preview-src-list="img.kurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.17</p>
                <!-- 4 -->
                <p class="describe">
                  4.点击“全部作废”作废该合同所有账单（如图1.18）合同随即转为预签状态，再次点击更多操作中的“合同修改”灰色方框内容即可修改）
                </p>
                <el-image 
                style="width:100%;"
                :src="img.lurl[0]"
                :preview-src-list="img.lurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.18</p>
                <!-- 5 -->
                <p class="describe">
                  5.点击合同管理中目标合同的合同编号（如图1.19）即可进入合同详细内容页面
                </p>
                <el-image 
                style="width:95%"
                :src="img.murl[0]"
                :preview-src-list="img.murl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.19</p>
                <!-- 6 -->
                <p class="describe">
                  6.页面最下方如图（1.20）有合同审批对接钉钉功能（物业房间清退、退房租单、退押金单、其他合同流转、主体变更等智慧湾独有，其他园区可查看审批流）
                </p>
                <el-image 
                style="width:95%;"
                :src="img.nurl[0]"
                :preview-src-list="img.nurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.20</p>
              </div>
              <!-- 合同延期 -->
              <div class="range" id="htyq">
                <h4 class="title">合同延期</h4>
                <el-divider></el-divider>
                <p class="describe">
                  1.点击目标合同更多操作中的“合同延期”（如图1.21）
                </p>
                <el-image 
                style="width:100%"
                :src="img.ourl[0]"
                :preview-src-list="img.ourl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.21</p>
                <p class="describe">
                  2.填写新的合同结束日期和备注说明（如图1.22）即可完成合同延期操作
                </p>
                <el-image 
                style="width:100%;"
                :src="img.purl[0]"
                :preview-src-list="img.purl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.22</p>
              </div>

              <!-- 合同退租 -->
              <div class="range" id="httz">
                <h4 class="title">合同退租</h4>
                <el-divider></el-divider>
                <p class="describe">
                  1.点击目标合同更多操作中的“合同退租”（如图1.23）
                </p>
                <el-image 
                style="width:100%"
                :src="img.qurl[0]"
                :preview-src-list="img.qurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.23</p>
                <p class="describe">
                  2.填写新的合同退租日期，该退款项金额及备注说明（如图1.24）即可完成合同退租操作
                </p>
                <el-image 
                style="width:100%;"
                :src="img.rurl[0]"
                :preview-src-list="img.rurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.24</p>
              </div>

              <!-- 合同账单查看和筛选 -->
              <div class="range" id="htzdckhsx">
                <h4 class="title">合同账单查看和筛选</h4>
                <el-divider></el-divider>
                <p class="describe">
                  1.点击小程序网页左侧“合同管理”跳转至合同管理页面，在客户名称右侧的白框中输入客户公司名称并点击最右侧蓝色按钮“查询”后即可显示该客户所有合同信息（如图1.25）
                </p>
                <el-image 
                style="width:100%;"
                :src="img.surl[0]"
                :preview-src-list="img.surl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.25</p>
                <p class="describe">
                  2.找到需要修改账单的合同，点击最右侧方框“更多操作”跳出下拉方框选择“合同账单”（如图1.26）
                </p>
                <el-image 
                style="width:100%"
                :src="img.turl[0]"
                :preview-src-list="img.turl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.26</p>

                <p class="describe">
                  3.即可跳出目标合同的账单（如图1.27）红色方框选择的内容可以进行账单类型、账单状态、账单金额、账单周期的筛选
                </p>
                <el-image 
                style="width:100%;"
                :src="img.uurl[0]"
                :preview-src-list="img.uurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.27</p>
              </div>

              <!-- 合同账单作废 -->
              <div class="range" id="htzdzf">
                <h4 class="title">合同账单作废</h4>
                <el-divider></el-divider>
                <p class="describe">
                  1.若目标账单日期需要修改则需要作废该账单并手动新建账单，可勾选多个账单后点击上侧“批量作废”按钮（如图1.28）
                </p>
                <el-image 
                style="width:100%"
                :src="img.vurl[0]"
                :preview-src-list="img.vurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.28</p>
              </div>

              <!-- 合同账单新建 -->
              <div class="range" id="htzdxj">
                <h4 class="title">合同账单新建</h4>
                <el-divider></el-divider>
                <p class="describe">
                  1.点击“新建账单”按钮（如图1.29）
                </p>
                <el-image 
                style="width:100%"
                :src="img.wurl[0]"
                :preview-src-list="img.wurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.29</p>
                 <p class="describe">
                  2.跳出新建账单详细内容框，可选择物业类型（租金、租金押金、物业费、物业押金、其他费用等），填写账单周期（开始——结束）、付款账号、付款周期（几个月一付）账单金额（月付金额），若付款周期为0（只有一个周期或多个不同付款周期）直接填写相应周期账单金额即可（如图1.30）
                </p>
                <el-image 
                style="width:85%"
                :src="img.xurl[0]"
                :preview-src-list="img.xurl"
                fit="'contain'"
                ></el-image>
                <p style="text-align:center">图1.30</p>
              </div>

            </div>
          </el-col>
          <el-col :span="8">
            <div class="col kefan">
              <el-timeline>
                  <ul>
                    
                    <li v-for="(activity, index) in lists" :key="index" >
                      <el-timeline-item
                      :icon="activity.icon"
                      :type="activity.type"
                      :color="activity.color"
                      :size="activity.size"
                      :timestamp="activity.timestamp">
                      <a :href="activity.target" @click="tolink(index)" :class="link==index?'islink':''">{{activity.name}}</a>
                    </el-timeline-item>
                    </li>
                    <li><el-progress :text-inside="true" :stroke-width="20" :percentage="percentage" color="#4fc08d"></el-progress></li>
                  </ul>
                  
                </el-timeline>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      percentage:0,
      lists: [
        {
          name: "管理后台入口",
          target: "#glhtrk",
        },
        {
          name: "合同查找",
          target: "#htcz",
        },
        {
          name: "合同添加",
          target: "#httj",
        },
        {
          name: "合同修改",
          target: "#htxg",
        },
        {
          name: "合同延期",
          target: "#htyq",
        },
        {
          name: "合同退租",
          target: "#httz",
        },
        {
          name: "合同账单查看和筛选",
          target: "#htzdckhsx",
        },
        {
          name: "合同账单作废",
          target: "#htzdzf",
        },
        {
          name: "合同账单新建",
          target: "#htzdxj",
        },
      ],
      link:0,
      img: {
        aurl: [this.$img + "htgl/1.8.png"],
        burl: [this.$img + "htgl/1.9.png"],
        curl: [this.$img + "htgl/1.10.png"],
        durl: [this.$img + "htgl/1.11.png"],
        eurl: [this.$img + "htgl/1.12.png"],
        furl: [this.$img + "htgl/1.13.png"],
        gurl: [this.$img + "htgl/1.13-1.png"],
        hurl: [this.$img + "htgl/1.14.png"],
        iurl: [this.$img + "htgl/1.15.png"],
        jurl: [this.$img + "htgl/1.16.png"],
        kurl: [this.$img + "htgl/1.17.png"],
        lurl: [this.$img + "htgl/1.18.png"],
        murl: [this.$img + "htgl/1.19.png"],
        nurl: [this.$img + "htgl/1.20.png"],
        ourl: [this.$img + "htgl/1.21.png"],
        purl: [this.$img + "htgl/1.22.png"],
        qurl: [this.$img + "htgl/1.23.png"],
        rurl: [this.$img + "htgl/1.24.png"],
        surl: [this.$img + "htgl/1.25.png"],
        turl: [this.$img + "htgl/1.26.png"],
        uurl: [this.$img + "htgl/1.27.png"],
        vurl: [this.$img + "htgl/1.28.png"],
        wurl: [this.$img + "htgl/1.29.png"],
        xurl: [this.$img + "htgl/1.30.png"],
      },
    };
  },
  mounted() {
    window.addEventListener('scroll',this.getscroll)
  },
  methods: {
    tolink(index) {
      this.link = index;
      
    },
    // 获取滚动百分比
    getscroll() {
      // 页面总高
      var totalH = document.documentElement.scrollHeight;
      // 可视高
      var clientH = document.documentElement.clientHeight;
      // 计算有效高
      var validH = totalH - clientH

      // 滚动条卷去高度
      var scrollH = document.documentElement.scrollTop;

      // 百分比
      var result = Math.round((scrollH/validH*10000)/100,2)
      this.percentage = result
      // console.log("totalH:" + totalH);
      // console.log("clientH:" + clientH);
      // console.log("scrollH:" + scrollH);
      if (result < 2) {
        this.tolink(0);
      } else if (result >= 2 && result < 10) {
        this.tolink(1);
      } else if (result >= 10 && result < 30) {
        this.tolink(2);
      } else if (result >= 30 && result < 54) {
        this.tolink(3);
      }else if (result >= 54 && result < 64) {
        this.tolink(4);
      }else if (result >= 64 && result < 72) {
        this.tolink(5);
      }else if (result >= 72 && result < 86) {
        this.tolink(6);
      }else if (result >= 86 && result < 92) {
        this.tolink(7);
      }else {
        this.tolink(8);
      }
    },
  },
  destroyed() {
    window.removeEventListener('scroll',this.getscroll)
  },
};
</script>

<style scoped>
.describe {
  font-size: 14px;
  color: #5e6d82;
}
.el-divider--horizontal {
  width: 80px;
  margin: 10px 0 15px 0;
  height: 3px;
  background-color: #4fc08d;
  box-shadow: 0px 3px 7px #4fc08d;
}
.range {
  margin: 0 0 10% 0;
}
.content p {
  width: 95%;
  word-break: break-all;
  word-wrap: break-word;
  padding: 10px 0;
}
.content {
  padding: 20px 40px;
}
:target {
  padding-top: 80px;
  margin-top: -80px;
}
.col {
  position: fixed;
  top: 80px;
  width: 300px;
  /* height: 30%; */
}
.col a {
  color: #5e6d82;
}
.col a:hover {
  color: #4fc08d;
}
.col a:after {
  color: #4fc08d;
  font-weight: 700;
}
.col .islink {
  color: #4fc08d;
  font-weight: 700;
}
.enterance {
  background: #5e6d82;
  color: aliceblue;
  border-radius: 8px;
  font-size: 14px;
  /* color: #5e6d82; */
}
.enterance li {
  padding: 5px 10px;
}
.describe::first-letter {
  font-size: 20px;
  font-weight: 700;
  text-shadow: 3px 2px 2px #4fc08d;
}
</style>